import { ProfileModuleModel } from "./ProfileModuleModel";

export class ProfileModel{
    Id : number;
    Nombre: string;
    Activo: boolean;
    IsDefault: boolean;
    CreadoPor:string;
    FechaCreacion: Date;
    ModificadoPor: string;
    FechaModificacion: Date;
    ProfileModuleModel : ProfileModuleModel[];
    ProfileMOdule(){
        this.Id=0;
        this.Nombre ="";
        this.Activo = true;
        this.IsDefault= false;
        this.CreadoPor ="";
        this.FechaCreacion = new Date();
        this.ModificadoPor = "";
        this.FechaModificacion = new Date();
    }
}
